<template>
    <div class="sec-cont">
        <Head :title="title"/>
        <div class="max-w-full bg-white rounded-md shadow overflow-hidden p-6">
            <form @submit.prevent="submitForm">

                <!-- Applicant Details Section -->
                <h2 class="text-xl font-bold mb-4">Activity Details</h2>


                <div class="flex flex-wrap -mb-8 -mr-6">
                    <select-input v-model="form.salutation" :error="form.errors?.salutation"
                                  class="pb-8 pr-6 w-full lg:w-1/6" :label="__('Select Activity')"
                    >
                        <option value="Mr.">{{ __('Activity') }}</option>
                        <option value="Ms.">{{ __('Training') }}</option>
                        <option value="Mrs.">{{ __('Workshop') }}</option>
                    </select-input>
                    <text-input class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Title')" type="text"/>

                    <text-input v-model="form.date_of_birth" :error="form.errors.date_of_birth"
                                class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Date')" type="date"
                                :max="currentDate"
                                @focus.native="$event.target.showPicker()"
                    />
                </div>


                <section class="s__2 mt-4 w-full lg:w-full">
                    <span class="form-label">{{ __('Description') }}</span>
                    <div v-if="!form.editDescription" class="prose pt-4 text-sm cursor-pointer"
                         @click="toggleDetails()" v-html="form.description || 'Add more details...'"
                    ></div>
                    <section v-if="form.editDescription">
                        <quill-editor ref="editDescription" @ready="onEditorReady" class="task__description"
                                      v-model:content="form.description" :options="editorOptions" contentType="html"
                                      theme="snow"
                        />
                    </section>
                </section>

                <div>
                    <!-- Class Dropdown -->
                    <div class="flex flex-wrap mt-4 -mb-8 -mr-6">
                        <select-input v-model="selectedClass" :error="form.errors?.salutation" @change="fetchStudents"
                                      class="pb-8 pr-6 w-full lg:w-1/6" :label="__('Select Class')"
                        >
                            <option value="" disabled>Select a class</option>
                            <option v-for="classItem in classList" :key="classItem.id" :value="classItem.id">
                                {{ classItem.name }}
                            </option>
                        </select-input>
                        <!-- Student Multi-select -->
                        <div class="pb-4 pr-6 w-full lg:w-1/3">
                            <multi-select-input2 id="cc"
                                                 :label="__('Select Student')"
                                                 v-model="selectedStudents"
                                                 :options="students"
                                                 required/>
                        </div>

                        <div class="pb-4 pr-6 w-full lg:w-1/3">
                            <multi-select-input2 id="cc"
                                                 :label="__('Select Teacher')"
                                                 v-model="selectedTeachers"
                                                 :options="teacherList"
                                                 required/>
                        </div>

                    </div>

                    <!-- Teacher Dropdown -->
<!--                    <label for="teacher">Select Teachers:</label>
                    <select v-model="" multiple>
                        <option value="all">Select All</option>
                        <option v-for="teacher in " :key="teacher.id" :value="teacher.id">
                            {{ teacher.name }}
                        </option>
                    </select>-->

                    <!-- Display Selected -->
                    <div v-if="selectedStudents.length || selectedTeachers.length">
                        <h3>Selection Summary:</h3>
                        <p>Selected Students: {{ selectedStudents }}</p>
                        <p>Selected Teachers: {{ selectedTeachers }}</p>
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="flex items-center justify-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo mx-auto" type="submit">{{
                            __('Submit')
                        }}
                    </loading-button>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import AcademicQualifications from '@/Pages/Interview/AcademicQualifications'
import {QuillEditor} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import MultiSelectInput2 from '@/Shared/MultiSelectInput2'

export default {

    components: {
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
        AcademicQualifications,
        QuillEditor,
        MultiSelectInput2,
    },
    layout: Layout,

    data() {
        return {

            classList: [
                {id: 1, name: 'Class 1'},
                {id: 2, name: 'Class 2'},
                {id: 3, name: 'Class 3'},
            ],
            teacherList: [
                {id: 1, name: 'Teacher A'},
                {id: 2, name: 'Teacher B'},
                {id: 3, name: 'Teacher C'},
            ],
            students: [],
            selectedClass: '',
            selectedStudents: [],
            selectedTeachers: [],
            form: this.$inertia.form({
                editDescription: true,
                salutation: '',
                name: '',
                father_name: '',
                date_of_birth: '',
                current_address: '',
                contact_number: '',
                marital_status: [],
                academic_qualifications: [],
                other_qualities: '',
                schooling_medium: '',
                schooling_name: '',
                favourite_subjects: '',
                teaching_class_limit: '',
                prefer_teaching_reason: '',
                reason_to_join: '',
                positive_points: '',
                negative_points: '',
                commitments: '',
                about_academy: '',
                previous_work_experience: '',
                leave_reason: '',
                salary_expectation: '',
                continue_duration: '',
                application_date: '',
                interview_status: '',
                errors: {},
                processing: false,
            }),
            editorOptions: {
                modules: {
                    toolbar: {
                        container: [
                            {'header': [1, 2, 3, 4, 5, 6, false]},
                            'bold', 'italic', 'underline', {'list': 'bullet'}, {'list': 'ordered'},
                            'align', 'clean',
                            'blockquote', 'code-block',
                            // 'image'
                        ],
                        // handlers: { 'image': this.imageButtonClickHandler }
                    },
                    // imageDrop: true,
                },
            },

            currentDate: new Date().toISOString().split('T')[0], // to set the max date
        }
    },
    watch: {
        selectedTeachers(newVal) {
            // Handle "Select All" logic for teachers
            if (newVal.includes('all')) {
                this.selectedTeachers = this.teacherList.map((teacher) => teacher.id)
            }
        },
    },
    methods: {
        fetchStudents() {
            // Simulate fetching students based on the selected class
            const allStudents = {
                1: [
                    {id: 101, name: 'Student A1'},
                    {id: 102, name: 'Student A2'},
                ],
                2: [
                    {id: 201, name: 'Student B1'},
                    {id: 202, name: 'Student B2'},
                ],
                3: [
                    {id: 301, name: 'Student C1'},
                    {id: 302, name: 'Student C2'},
                ],
            }
            this.students = allStudents[this.selectedClass] || []
            this.selectedStudents = [] // Reset selection when class changes
        },
        validateForm() {
            this.form.errors = {} // Reset errors

            if (!this.form.salutation) this.form.errors.salutation = 'Salutation name is required'
            if (!this.form.name) this.form.errors.name = 'Applicant name is required'
            if (!this.form.father_name) this.form.errors.father_name = 'Father name is required'
            if (!this.form.date_of_birth) this.form.errors.date_of_birth = 'Date of birth is required'
            if (!this.form.contact_number) {
                this.form.errors.contact_number = 'Contact number is required'
            } else if (!/^\d{10}$/.test(this.form.contact_number)) {
                this.form.errors.contact_number = 'Contact number must be 10 digits'
            }

            if (this.form.marital_status.length <= 0) {
                this.form.errors.marital_status = 'Marital status is required'
            }
            if (!this.form.current_address) this.form.errors.current_address = 'Current address is required'

            const academicQualificationsComponent = this.$refs.academicQualifications

            // Validate the academic qualifications
            academicQualificationsComponent.validateRows()

            if (!this.form.schooling_name) this.form.errors.schooling_name = 'Schooling name is required'
            if (!this.form.schooling_medium) this.form.errors.schooling_medium = 'Schooling medium is required'
            if (!this.form.favourite_subjects) this.form.errors.favourite_subjects = 'Favourite subjects is required'
            if (!this.form.teaching_class_limit) this.form.errors.teaching_class_limit = 'Teaching class limit is required'
            if (!this.form.reason_to_join) this.form.errors.reason_to_join = 'Current address is required'
            if (!this.form.about_academy) this.form.errors.about_academy = 'Current address is required'
            if (!this.form.prefer_teaching_reason) this.form.errors.prefer_teaching_reason = 'Current address is required'
            if (!this.form.positive_points) this.form.errors.positive_points = 'Current address is required'
            if (!this.form.negative_points) this.form.errors.negative_points = 'Current address is required'
            if (!this.form.previous_work_experience) this.form.errors.previous_work_experience = 'Current address is required'
            if (!this.form.leave_reason) this.form.errors.leave_reason = 'Leave reason is required'
            if (!this.form.salary_expectation) this.form.errors.salary_expectation = 'Salary expectation is required'
            if (!this.form.continue_duration) this.form.errors.continue_duration = 'Duration is required'
            if (!this.form.other_qualities) this.form.errors.other_qualities = 'Other qualities is required'
            if (!this.form.commitments) this.form.errors.commitments = 'Commitments is required'
            if (!this.form.application_date) this.form.errors.application_date = 'Application date is required'
            if (!this.form.interview_status) this.form.errors.interview_status = 'Application status is required'

            return Object.keys(this.form.errors).length === 0
        },

        submitForm() {
            if (this.validateForm()) {
                this.form.processing = true
                this.form.post(this.route('admin.storeInterviewData'), {
                    onSuccess: () => {
                        this.form.reset()
                        this.$refs.academicQualifications.resetRows()
                    },
                })
            }
        },
        onEditorReady(editor) {
            editor.focus()
        },
        toggleDetails() {
            this.form.editDescription = true
            this.$refs.form.editDescription.focus()
        },
    },

}
</script>
<style scoped>
label {
    margin-right: 10px;
}

select {
    margin-bottom: 20px;
}
</style>
